import React, { useState } from "react";
import { deleteDoc, doc } from "firebase/firestore";
import { useFirestore, useSigninCheck } from "reactfire";

import { DsButton } from "./ui/DsButton";
import { DsConfirmationModal } from "./ui/DsConfirmationModal";

type DeleteDocModalPropsType = {
  buttonClassName?: string;
  buttonContent: React.ReactNode;
  path: string;
  type: "note" | "site" | "customer";
  onSuccess?: () => void;
};

export const DeleteDocModal = ({
  buttonClassName,
  buttonContent,
  path,
  type,
  onSuccess,
}: DeleteDocModalPropsType) => {
  const [isOpen, setIsOpen] = useState(false);
  const firestore = useFirestore();
  const ref = doc(firestore, path);

  const handleDelete = () => {
    void deleteDoc(ref);
    if (onSuccess) onSuccess();
    setIsOpen(false);
  };

  const { status, data: signInCheckResult } = useSigninCheck({
    // Only have managers able to delete notes
    requiredClaims: type === "note" ? { manager: true } : { superadmin: true },
  });

  if (
    status === "loading" ||
    !signInCheckResult?.signedIn ||
    !signInCheckResult?.hasRequiredClaims
  ) {
    return null;
  }

  return (
    <>
      <DsButton
        variant="secondary"
        className={buttonClassName}
        onClick={() => setIsOpen(true)}>
        {buttonContent}
      </DsButton>
      <DsConfirmationModal
        isOpen={isOpen}
        onCancel={() => setIsOpen(false)}
        onConfirm={handleDelete}
        title="delete_doc_modal.title"
        titlei18nOptions={{ type }}
        message="delete_doc_modal.message"
        messagei18nOptions={{ type }}
        hasConfirmationInpupt
        confirmationText={type}
      />
    </>
  );
};
